import React, { FC } from "react";

import { startOfMonth, endOfMonth } from "date-fns";

import {
  useDateRange,
  useMultiDivisionMultiSectionDropdown,
  useProvidersCurrentEmployee,
  useApisAnalyticsPlansCumulativeAnalysisIndex,
} from "~/hooks";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
} from "~/components/layouts";
import { AnalyticsCumulativeAnalysisTemplate } from "~/components/templates";

const today = new Date();

export const AnalyticsPlansCumulativeAnalysisIndex: FC = () => {
  const { currentEmployee } = useProvidersCurrentEmployee();

  const breadCrumbItems = [
    {
      label: "累計分析",
      href: "/analytics_plans/cumulative_analysis",
    },
  ];

  const {
    selectableDivisions,
    selectedDivisions,
    onDivisionChange,
    optionSelectableSections,
    optionSelectedSections,
    onSectionChange,
    selectableEmployees,
    selectedEmployee,
    onEmployeeChange,
  } = useMultiDivisionMultiSectionDropdown({
    selectableDivisions: currentEmployee?.businessDivisions,
    selectableSections: currentEmployee?.businessSections,
    isSelectEmployee: true,
  });

  const [
    {
      startDate,
      formattedStartDate,
      endDate,
      formattedEndDate,
      dateArray,
      onChange: onChangeDateRange,
    },
  ] = useDateRange([startOfMonth(today), endOfMonth(today)]);

  const { data, isLoading } = useApisAnalyticsPlansCumulativeAnalysisIndex({
    params: {
      businessDivisionIds: selectedDivisions.map((division) => division.id),
      businessSectionIds: optionSelectedSections.map((section) => section.id),
      fromDate: formattedStartDate || undefined,
      toDate: formattedEndDate || undefined,
      employeeIds: selectedEmployee ? [selectedEmployee.id] : undefined,
    },
    config: {
      enabled: !!(formattedStartDate && formattedEndDate),
    },
  });

  return (
    <>
      <EmployeeLayout
        withRightSidebar={false}
        breadCrumbItems={breadCrumbItems}
      >
        <EmployeeLayoutMainContent withRightSidebar={false}>
          <AnalyticsCumulativeAnalysisTemplate
            formattedStartDate={formattedStartDate}
            formattedEndDate={formattedEndDate}
            selectedDivisions={selectedDivisions}
            optionSelectedSections={optionSelectedSections}
            selectedEmployee={selectedEmployee}
            data={data}
            isLoading={isLoading}
            onChangeDateRange={onChangeDateRange}
            onDivisionChange={onDivisionChange}
            onSectionChange={onSectionChange}
            onEmployeeChange={onEmployeeChange}
            selectableDivisions={selectableDivisions}
            optionSelectableSections={optionSelectableSections}
            selectableEmployees={selectableEmployees}
            startDate={startDate}
            endDate={endDate}
            selectedDropdownSections={optionSelectedSections}
            dateArray={dateArray}
          />
        </EmployeeLayoutMainContent>
      </EmployeeLayout>
    </>
  );
};
